import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import styled from 'styled-components';

const FooterContainer = styled(Box)`
  width: 100%;
  padding: 20px 0;
  background-color: #f5f5f5;
  margin-top: auto;
`;

const FooterContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const Footer = () => {
  return (
    <FooterContainer component="footer">
      <FooterContent>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} 在线简历制作
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <Link 
            href="https://beian.miit.gov.cn/" 
            target="_blank" 
            rel="noopener noreferrer"
            color="inherit"
            underline="hover"
          >
            鄂ICP备2025103271号
          </Link>
        </Typography>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 